import React from 'react';

const optimizedImageBaseUrl = 'https://teinnovations.com/wp-content/catalog-images/optimized/';
const homeOptimizedMapping = {
  'film-on-machine': {
    avif: 'film-on-machine.avif',
    webp: 'film-on-machine.webp',
    fallback: 'film-on-machine.jpg',
    alt: 'Film on machine'
  }
};

const homeItems = [
  {
    key: 'films',
    title: 'Films',
    image: 'https://teinnovations.com/wp-content/uploads/2017/07/film-on-machine.jpg',
    baseFilename: 'film-on-machine'
  },
  {
    key: 'containers',
    title: 'Food Containers',
    image: 'https://teinnovations.com/wp-content/uploads/2016/12/food-trays-on-table-med-1440x550.jpg',
    baseFilename: 'food-trays-on-table-med-1440x550'
  },
  {
    key: 'sealing',
    title: 'Sealing Machines',
    image: 'https://teinnovations.com/wp-content/uploads/2017/02/1350-cutout-scaled.jpg',
    baseFilename: '1350-cutout-scaled'
  },
  {
    key: 'consulting',
    title: 'Consulting',
    image: 'https://teinnovations.com/wp-content/catalog-images/optimized/consulting.webp',
    baseFilename: 'consulting'
  }
];

const SmallNavigationCards = ({ onNavigate }) => {
  return (
    <div className="grid grid-cols-2 gap-3">
      {homeItems.map((item) => {
        const optimizedData = homeOptimizedMapping[item.baseFilename];
        return (
          <div
            key={item.key}
            onClick={(e) => {
              e.stopPropagation();
              onNavigate(item.key);
            }}
            className="relative group cursor-pointer rounded-lg overflow-hidden h-32 shadow-md hover:scale-105 active:scale-95 transition-transform duration-200"
          >
            {optimizedData ? (
              <picture className="absolute inset-0">
                <source srcSet={`${optimizedImageBaseUrl}${optimizedData.avif}`} type="image/avif" />
                <source srcSet={`${optimizedImageBaseUrl}${optimizedData.webp}`} type="image/webp" />
                <img
                  src={`${optimizedImageBaseUrl}${optimizedData.fallback}`}
                  alt={optimizedData.alt || item.title}
                  className="w-full h-full object-cover"
                />
              </picture>
            ) : (
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${item.image})` }}
              />
            )}

            <div className="absolute inset-0 bg-black bg-opacity-50 group-hover:bg-opacity-60 transition-opacity duration-200" />

            <div className="relative z-10 flex items-center justify-center h-full">
              <h4 className="text-white text-xl font-bold text-center px-2 uppercase">
                {item.title}
              </h4>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SmallNavigationCards;
